var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeviceTypeTablet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1209_6046)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.75,
    y: 1.51074,
    width: 60,
    height: 60,
    rx: 30,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1209_6046)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.75 13.5107H22.75C20.26 13.5107 18.25 15.5207 18.25 18.0107V45.0107C18.25 47.5007 20.26 49.5107 22.75 49.5107H40.75C43.24 49.5107 45.25 47.5007 45.25 45.0107V18.0107C45.25 15.5207 43.24 13.5107 40.75 13.5107ZM34.75 46.5107H28.75V45.0107H34.75V46.5107ZM42.625 42.0107H20.875V18.0107H42.625V42.0107Z",
    fill: "#4739E7"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 2.25,
    y: 2.01074,
    width: 59,
    height: 59,
    rx: 29.5,
    stroke: "#4739E7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1209_6046",
    x: 0.75,
    y: 0.510742,
    width: 62,
    height: 62,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1209_6046"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.878431 0 0 0 0 0.878431 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1209_6046"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1209_6046",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1209_6046"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(13.75 13.5107)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceTypeTablet);
export default __webpack_public_path__ + "static/media/device-type-tablet.06f63af31376eb3d9757552910e60e8b.svg";
export { ForwardRef as ReactComponent };